import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughLocationProps = {
  node: ConversationFlowAuditLogEntry<'PHONE_NUMBER_ROUTING_NODE_VISITED'>;
};

export function RoutedThroughLocation({
  node,
}: RoutedThroughLocationProps): JSX.Element {
  return (
    <>
      Location ·{' '}
      {node.is_matching === true ? (
        <strong>{node.matching_rule_name}</strong>
      ) : (
        'No match'
      )}
    </>
  );
}
